import loginReducer from "../pages/Login/actions/LoginActions";

const rootReducer = {
    login : loginReducer
}

export default rootReducer